export const questionMenuData = [
    {
        name: "FAQ",
        path: "https://docs.credix.finance/other-links-and-resources/faq",
        target: true,
    },
    {
        name: "Documents",
        path: "https://docs.credix.finance/",
        target: true,
    },
    {
        name: "investor@credix.finance",
        path: "mailto:investor@credix.finance",
        target: false,
    },
]